import { render, staticRenderFns } from "./throughReview.vue?vue&type=template&id=61166654&scoped=true&"
import script from "./throughReview.vue?vue&type=script&lang=js&"
export * from "./throughReview.vue?vue&type=script&lang=js&"
import style0 from "./throughReview.vue?vue&type=style&index=0&id=61166654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61166654",
  null
  
)

export default component.exports